var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGalleryView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 5,
    width: 11,
    height: 6,
    rx: 1,
    fill: "current"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 11,
    height: 6,
    rx: 1,
    fill: "current"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 11,
    height: 6,
    rx: 1,
    fill: "current"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 13,
    width: 11,
    height: 6,
    rx: 1,
    fill: "current"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHg9IjEzIiB5PSI1IiB3aWR0aD0iMTEiIGhlaWdodD0iNiIgcng9IjEiIGZpbGw9ImN1cnJlbnQiLz4KPHJlY3QgeD0iMTMiIHk9IjEzIiB3aWR0aD0iMTEiIGhlaWdodD0iNiIgcng9IjEiIGZpbGw9ImN1cnJlbnQiLz4KPHJlY3QgeT0iNSIgd2lkdGg9IjExIiBoZWlnaHQ9IjYiIHJ4PSIxIiBmaWxsPSJjdXJyZW50Ii8+CjxyZWN0IHk9IjEzIiB3aWR0aD0iMTEiIGhlaWdodD0iNiIgcng9IjEiIGZpbGw9ImN1cnJlbnQiLz4KPC9zdmc+Cg==";
export { SvgGalleryView as ReactComponent };